import { CellContext } from '@tanstack/react-table';

export const TimestampCellRenderer = <TData, TValue>(props: CellContext<TData, TValue>): JSX.Element => {
  const value = props.getValue() as string;

  const displayValue = value != null ? value : '—';

  return <div>{displayValue}</div>;
};
